import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "flex-center text-slate-600 text-xl mb-4"
};
const _hoisted_2 = {
  class: "flex-center pt-4"
};
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import { GoalIncident, SubstitutionIncident } from "@/modules/match/entity";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'LiveIncident',
  props: {
    liveIncident: null,
    disabled: {
      type: Boolean
    },
    liveMatchEvaluator: null
  },
  emits: ['disable-incidents'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const incidentComponent = computed(() => props.liveIncident.incident.liveComponent);
    const getWaitForMS = () => {
      if (props.liveIncident.incident instanceof GoalIncident) {
        return 4000;
      }
      if (props.liveIncident.incident instanceof SubstitutionIncident) {
        return 1000;
      }
      return 1500;
    };
    const dialog = ref(null);
    const resolve = ref();
    const show = () => {
      paused.value = false;
      dialog.value.show();
      return new Promise(async r => {
        resolve.value = () => {
          dialog.value.hide();
          r(undefined);
        };
        await waitFor(getWaitForMS());
        resolve.value();
      });
    };
    const hide = () => {
      resolve.value();
    };
    const paused = ref(false);
    const onClickDisableIncidents = () => {
      onClickPause();
      emit('disable-incidents');
    };
    const onClickPause = () => {
      paused.value = true;
      props.liveMatchEvaluator.pause();
    };
    expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(RichDialog, {
        ref_key: "dialog",
        ref: dialog,
        "hide-actions": ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('x_minute', {
          minute: __props.liveIncident.minute
        })), 1), _unref(incidentComponent) ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(incidentComponent)), _mergeProps({
          key: 0
        }, {
          liveIncident: __props.liveIncident
        }, {
          class: "text-2xl"
        }), null, 16)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(_component_NButton, {
          secondary: "",
          type: "error",
          loading: paused.value,
          disabled: paused.value,
          onClick: onClickPause
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: _ctx.IconEnum.Pause20Regular
          }, null, 8, ["icon"])]),
          _: 1
        }, 8, ["loading", "disabled"]), _createVNode(_component_NButton, {
          secondary: "",
          type: "error",
          disabled: paused.value,
          class: "ml-2",
          onClick: onClickDisableIncidents
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: _ctx.IconEnum.AlertOn20Regular
          }, null, 8, ["icon"])]),
          _: 1
        }, 8, ["disabled"])])]),
        _: 1
      }, 512);
    };
  }
});